import React from 'react';
import { ArrowRight } from 'lucide-react';

const Fingertips = () => {
  return (
    <section className="relative bg-[#FAF2E8] pt-14 pb-4 md:pt-20 md:pb-6 overflow-hidden" data-testid="fingertips">
      <div className="absolute left-1/2 -translate-x-1/2 top-40 w-[700px] h-[400px] rounded-full blur-3xl opacity-40" style={{ background: 'radial-gradient(closest-side, #F4C7F0, transparent 70%)' }} />

      <div className="relative max-w-5xl mx-auto px-5 text-center">
        <h2 className="text-3xl md:text-5xl font-extrabold text-neutral-900">
          Everything at your{' '}
          <span className="relative inline-block text-[#F39200]">
            fingertips
            <svg className="absolute -bottom-2 left-0 w-full" height="10" viewBox="0 0 280 10" fill="none">
              <path d="M2 7 C 70 1, 160 1, 278 6" stroke="#F39200" strokeWidth="2" strokeLinecap="round" fill="none" />
            </svg>
          </span>
        </h2>
        <p className="mt-5 max-w-2xl mx-auto text-neutral-600 text-[15px]">
          Streamline your communication and eliminate the hassle of calls, texts, and delayed responses. One stop solution for all your compliance needs.
        </p>
        <a href="#contact" className="inline-flex items-center gap-2 mt-7 bg-neutral-900 hover:bg-neutral-800 text-white px-5 h-11 rounded-lg text-sm font-medium transition-colors">
          Get a Quote <ArrowRight size={16} />
        </a>
      </div>

      {/* Widened, negative-margin image — fills the viewport for maximum impact */}
      <div className="relative mt-10 md:mt-14 mx-2 md:-mx-6 lg:-mx-16 xl:-mx-24">
        <img
          src="/logos/dashboard.svg"
          alt="EasyWorks dashboard preview"
          className="block w-[85%] mx-auto h-auto drop-shadow-2xl"
          loading="lazy"
          data-testid="fingertips-image"
        />
      </div>
    </section>
  );
};

export default Fingertips;
